import { URL_LIST_JOBS_EXPIRED } from '@seek/adv-constants';
import { useTranslations } from '@vocab/react';
import { Box, IconCopy, Text, TextLinkButton } from 'braid-design-system';
import React from 'react';
import { useSelector } from 'react-redux';

import { EVENT_NAME_INTERACTION } from 'src/app/analytics';
import getTrackingAdapter from 'src/app/dataAnalytics';
import { USE_PREVIOUS_JOB_PRESSED } from 'src/app/dataAnalytics/schema/constants';
import {
  FEATURE_DATA_ANALYTICS,
  useFeatureToggleData,
} from 'src/app/featureToggle';
import { sendLinkEvent } from 'src/app/utils/analytics';
import { useLocalisedRoutes } from 'src/app/views/hooks/useLocalisedRoutes';
import type AppState from 'src/types/appState';

import translations from './.vocab';

const ANALYTICS_LINK_NAME = 'ecaja-use-previous-job-clicked';
const OBJECT_INTERACTION = 'use-previous-job';

const CopyJob = () => {
  const { t } = useTranslations(translations);
  const { goToExternalRoute } = useLocalisedRoutes();
  const tealium = useSelector((state: AppState) => state.tealium);

  const isPageAnalyticsEnabled = useFeatureToggleData(FEATURE_DATA_ANALYTICS);

  const handleOnClick = () => {
    if (isPageAnalyticsEnabled) {
      const eventData = {
        eventName: USE_PREVIOUS_JOB_PRESSED,
        objectInteraction: OBJECT_INTERACTION,
      };
      getTrackingAdapter.sendLinkEvent(eventData);
    } else {
      const eventData = {
        linkName: ANALYTICS_LINK_NAME,
        eventName: [EVENT_NAME_INTERACTION, ANALYTICS_LINK_NAME],
        objectInteraction: OBJECT_INTERACTION,
      };
      sendLinkEvent(tealium, eventData);
    }
    goToExternalRoute(`${URL_LIST_JOBS_EXPIRED}&source=caja`);
  };

  return (
    <Box background="surface" padding="large">
      <Text tone="neutral" size="large">
        <TextLinkButton onClick={handleOnClick}>
          <IconCopy /> {t('copy-job-button-label')}
        </TextLinkButton>
      </Text>
    </Box>
  );
};

export default CopyJob;
